import { lazy } from 'react';

const AcademicsModal = lazy(() => import('./modals/AcademicsModal'));
const CompleteApplicationModal = lazy(
  () => import('./modals/CompleteApplication'),
);
const DeadlinePassed = lazy(() => import('./modals/DeadlinePassed'));
const AddResultModal = lazy(() => import('./modals/AddResult'));
const AddSchoolModal = lazy(() => import('./modals/AddSchool'));
const EditApplicationRequirementModal = lazy(
  () => import('./modals/EditRequirement'),
);
const ConfirmInProgress = lazy(() => import('./modals/ConfirmInProgress'));
const RecommenderListView = lazy(() => import('./modals/RecommenderListView'));
const AcceptanceModal = lazy(() => import('./modals/AcceptanceModal'));
const AwardLetterDetails = lazy(
  () => import('./modals/AcceptanceModal/AwardLetterDetails'),
);
const CommonAppHandoffModal = lazy(
  () => import('./modals/CommonAppHandoffModal'),
);
const ChangeApplicationMethodModal = lazy(
  () =>
    import(
      './pages/StudentApplication/components/ChangeApplicationMethodModal'
    ),
);
const FerpaWaiverModal = lazy(() => import('./modals/FerpaModal'));
const StudentAddressModal = lazy(() => import('./modals/StudentAddressModal'));
const FeeWaiverChecklistModal = lazy(
  () => import('./modals/FeeWaiverChecklistModal'),
);
const StudentOnboardingModal = lazy(
  () => import('./modals/StudentOnboardingModal'),
);
const CommonAppSetupModal = lazy(
  () => import('./components/ApplicationSetup/components/CommonAppSetup'),
);
const RecommendationRequestModal = lazy(
  () => import('./modals/RecommendationRequestModal'),
);
const ApplicationStatusModal = lazy(
  () => import('./pages/StudentApplication/components/ApplicationStatusModal'),
);
const ApplicationInProgressModal = lazy(
  () => import('./modals/ApplicationInProgressModal'),
);
const AddEnrolmentDecision = lazy(
  () => import('./modals/AddEnrolmentDecision'),
);
const EnrolledSchool = lazy(() => import('./modals/EnrolledSchool'));
const RecommenderLetterPortalHelpModal = lazy(
  () => import('./modals/RecommenderLetterPortalHelpModal'),
);
const RecommendationDocumentDrawer = lazy(
  () => import('./modals/RecommendationDocumentDrawer'),
);
const RecommendationFormDrawer = lazy(
  () => import('./modals/RecommendationFormDrawer'),
);
const DeclineRecommendationModal = lazy(
  () => import('./modals/DeclineRecommendationModal'),
);
const ApplicationAlreadyExistModal = lazy(
  () => import('./modals/ApplicationAlreadyExistModal'),
);
const RecommendationNoteModal = lazy(
  () => import('./modals/RecommendationNoteModal'),
);

const BulkAppAction = lazy(
  () => import('modules/CollegeApplicationManager/modals/BulkAppAction'),
);
const RemoveRequirementModal = lazy(
  () =>
    import(
      'modules/CollegeApplicationManager/pages/DocumentManagerList/components/GridRow/components/RemoveRequirementModal'
    ),
);
const AddRequirementModal = lazy(
  () =>
    import(
      'modules/CollegeApplicationManager/pages/DocumentManagerList/components/AddRequirementModal'
    ),
);
const RequirementDocumentDrawer = lazy(
  () =>
    import(
      'modules/CollegeApplicationManager/pages/DocumentManagerList/components/RequirementDocumentDrawer'
    ),
);
const RequirementFormDrawer = lazy(
  () =>
    import(
      'modules/CollegeApplicationManager/pages/DocumentManagerList/components/RequirementFormDrawer'
    ),
);
const TranscriptDrawer = lazy(
  () =>
    import(
      'modules/CollegeApplicationManager/pages/DocumentManagerList/components/TranscriptDrawer'
    ),
);
const IncompleteSchoolProfileDrawer = lazy(
  () =>
    import(
      'modules/CollegeApplicationManager/pages/DocumentManagerList/components/IncompleteSchoolProfileDrawer'
    ),
);
const DocumentSentMethodModal = lazy(
  () =>
    import(
      'modules/CollegeApplicationManager/pages/DocumentManagerList/components/DocumentSentMethodModal'
    ),
);
const UploadAppRequirementDocumentModal = lazy(
  () =>
    import(
      'modules/CollegeApplicationManager/modals/UploadAppRequirementDocumentModal'
    ),
);
const VerifyDestinationModal = lazy(
  () =>
    import('modules/CollegeApplicationManager/modals/VerifyDestinationModal'),
);

const StudentListDrawer = lazy(
  () => import('modules/CollegeApplicationManager/modals/StudentListDrawer'),
);
const CommonAppBulkSendApprovalModal = lazy(
  () =>
    import(
      'modules/CollegeApplicationManager/modals/CommonAppBulkSendApprovalModal'
    ),
);
const BulkSendPreviewModal = lazy(
  () => import('modules/CollegeApplicationManager/modals/BulkSendPreviewModal'),
);

export default {
  ACADEMICS_MODAL: AcademicsModal,
  ACCEPTANCE_MODAL: AcceptanceModal,
  ADD_SCHOOL_MODAL: AddSchoolModal,
  COMPLETE_APPLICATION_MODAL: CompleteApplicationModal,
  COMMON_APP_HANDOFF: CommonAppHandoffModal,
  CONFIRM_IN_PROGRESS: ConfirmInProgress,
  EDIT_APP_REQUIREMENT_MODAL: EditApplicationRequirementModal,
  RECOMMENDER_LIST_VIEW: RecommenderListView,
  ADD_RESULT: AddResultModal,
  DEADLINE_PASSED: DeadlinePassed,
  CHANGE_APPLICATION_METHOD: ChangeApplicationMethodModal,
  FERPA_WAIVER_MODAL: FerpaWaiverModal,
  STUDENT_ADDRESS_MODAL: StudentAddressModal,
  FEE_WAIVER_CHECKLIST_MODAL: FeeWaiverChecklistModal,
  STUDENT_ONBOARDING_MODAL: StudentOnboardingModal,
  COMMON_APP_SETUP_MODAL: CommonAppSetupModal,
  RECOMMENDATION_REQUEST_MODAL: RecommendationRequestModal,
  APPLICATION_STATUS_MODAL: ApplicationStatusModal,
  APPLICATION_IN_PROGRESS_MODAL: ApplicationInProgressModal,
  AWARD_LETTER_DETAILS_MODAL: AwardLetterDetails,
  ADD_ENROLMENT_DECISION: AddEnrolmentDecision,
  ENROLLED_SCHOOL: EnrolledSchool,
  RECOMMENDER_LETTER_PORTAL_HELP_MODAL: RecommenderLetterPortalHelpModal,
  RECOMMENDATION_DOCUMENT_DRAWER: RecommendationDocumentDrawer,
  RECOMMENDATION_FORM_DRAWER: RecommendationFormDrawer,
  DECLINE_RECOMMENDATION_MODAL: DeclineRecommendationModal,
  APPLICATION_ALREADY_EXIST_MODAL: ApplicationAlreadyExistModal,
  RECOMMENDATION_NOTE_MODAL: RecommendationNoteModal,
  BULK_APP_ACTION: BulkAppAction,
  VERIFY_DESTINATION_MODAL: VerifyDestinationModal,
  UPLOAD_APP_REQUIREMENT_DOCUMENT_MODAL: UploadAppRequirementDocumentModal,
  DOCUMENT_SENT_METHOD: DocumentSentMethodModal,
  REMOVE_REQUIREMENT_MODAL: RemoveRequirementModal,
  ADD_REQUIREMENT_MODAL: AddRequirementModal,
  REQUIREMENT_DOCUMENT_DRAWER: RequirementDocumentDrawer,
  REQUIREMENT_FORM_DRAWER: RequirementFormDrawer,
  INCOMPLETE_SCHOOL_PROFILE_DRAWER: IncompleteSchoolProfileDrawer,
  TRANSCRIPT_DRAWER: TranscriptDrawer,
  STUDENT_LIST_DRAWER: StudentListDrawer,
  COMMON_APP_BULK_SEND_APPROVAL_MODAL: CommonAppBulkSendApprovalModal,
  BULK_SEND_PREVIEW_MODAL: BulkSendPreviewModal,
};
